import { Plus } from 'lucide-react'
import { Label } from '../../../../components/ui/label'
import { BasicInput } from '../../../../components/BasicInput'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog'
import { Textarea } from '../../../../components/ui/textarea'
import { useTeamAddController } from './useTeamAddController'
import { PrefixInput } from '../../../../components/PrefixInput'
import { Button } from '@/view/components/ui/button'
// import GoalsForm from '@/view/components/GoalsForm'
import { phoneMask } from '@/app/utils/phoneFormater'

const TEAMS_URL = import.meta.env.VITE_TEAMS_URL

export const TeamAdd = () => {
  const { methods, handleAddTeam, isPending, open, setOpen } =
    useTeamAddController()

  return (
    <div>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>
          <div className="flex h-10 w-36 items-center justify-center gap-2 rounded-full bg-primary text-white">
            <div className="flex h-5 w-5 items-center justify-center rounded-full bg-white">
              <Plus size={14} className="text-primary" />
            </div>
            <p className="font-semibold">Nova equipe</p>
          </div>
        </AlertDialogTrigger>
        <AlertDialogContent className="max-w-full overflow-auto p-0 sm:w-fit">
          <form onSubmit={methods.handleSubmit(handleAddTeam)} className="">
            <AlertDialogHeader className="p-5">
              <AlertDialogTitle>Criar nova equipe</AlertDialogTitle>
            </AlertDialogHeader>
            <div className="border-b-[1px] border-white02" />
            <div className="flex max-h-[780px] flex-col gap-5 overflow-y-auto p-5 lg:flex-row">
              <div className="flex w-full flex-col items-center gap-5 pb-0">
                <BasicInput
                  label="Nome da equipe"
                  name="name"
                  placeholder="Nome da equipe"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.name?.message}
                />

                <PrefixInput
                  label="Link para a equipe"
                  prefix={TEAMS_URL}
                  name="code"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.code?.message}
                />

                <div className="w-full">
                  <Label htmlFor="about" className="w-full">
                    Descrição
                    <Textarea
                      {...methods.register('about')}
                      name="about"
                      placeholder="Descrição da equipe"
                      className="mt-2 h-40 w-full resize-none bg-white02"
                    />
                    {methods.formState.errors.about?.message && (
                      <p className="text-sm font-light text-error">
                        {methods.formState.errors.about?.message}
                      </p>
                    )}
                  </Label>
                </div>

                <BasicInput
                  name="supportPhone"
                  label="Telefone para Suporte"
                  type="text"
                  onInput={phoneMask}
                  placeholder="(00) 00000-0000"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.supportPhone?.message}
                />
              </div>
              {/* <div className="min-w-[450px]">
                <GoalsForm useDefault />
              </div> */}
            </div>

            <AlertDialogFooter className="space-x-2 border-t-[1px] border-white02 p-5 ">
              <AlertDialogCancel className="rounded-full bg-white02">
                Cancelar
              </AlertDialogCancel>
              <Button
                disabled={isPending}
                type="submit"
                className="rounded-full bg-primary text-white"
              >
                Criar equipe
              </Button>
            </AlertDialogFooter>
          </form>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
